import { PaymentMethod, PaymentMethodDetailResult } from '@mews-commander/data-access';
import { SepaStatusHistoryBody } from './SepaStatusHistoryBody';
import { CardStatusHistoryBody } from './CardStatusHistoryBody';
import { PaymentMethodDetailStatusHistoryAccordion } from './PaymentMethodDetailStatusHistoryAccordion';
import { DetailStatusHistoryPrimaryText } from './DetailStatusHistoryPrimaryText';

export const PaymentMethodDetailStatusHistory = ({
    paymentMethod,
    paymentMethodType,
}: {
    paymentMethod: PaymentMethodDetailResult;
    paymentMethodType: PaymentMethod;
}) => {
    switch (paymentMethodType) {
        case PaymentMethod.SepaDirectDebit:
            return (
                <>
                    {paymentMethod.sepa?.statusHistory?.map((status) => (
                        <PaymentMethodDetailStatusHistoryAccordion
                            key={status.createdUtc}
                            primaryText={
                                <DetailStatusHistoryPrimaryText
                                    createdUtc={status.createdUtc}
                                    status={status.newStatus}
                                />
                            }
                            body={<SepaStatusHistoryBody status={status} />}
                        />
                    ))}
                </>
            );

        case PaymentMethod.PaymentCard:
            return (
                <>
                    {paymentMethod.paymentCard?.statusHistory?.map((status) => (
                        <PaymentMethodDetailStatusHistoryAccordion
                            key={status.statusUpdatedUtc}
                            primaryText={
                                <DetailStatusHistoryPrimaryText
                                    createdUtc={status.statusUpdatedUtc}
                                    status={status.newStatus}
                                />
                            }
                            body={<CardStatusHistoryBody status={status} />}
                        />
                    ))}
                </>
            );

        default:
            return null;
    }
};
